export default {
  "header": "BUZZZZZZZZZ",
  "quotes": {
    new_york_times: '“Materials and details are thoughtful, and the clothes are wildly cute.”',
    today_show: '“The clothing is so stylish and so affordable...and the softest quality.”',
    people_magazine: '“They\'ll be at the top of their playground game with these clothes.”',
    tech_crunch: '“Rockets of Awesome is a total no brainer.”',
    fast_company: '“Shopping for kids’ clothes can be fun.”',
    parents_magazine: '“You can’t buy these clothes in stores.”',
    la_times: '“Obsessively kid friendly.”',
    new_york_post: '“The witty graphics, throwback bombers and metallic-accented tutus from this fashion-forward label are all about encouraging kids \'to be their authentic selves.\''
  },
  "order": ["new_york_times", "today_show", "people_magazine", "tech_crunch", "fast_company", "parents_magazine", "la_times", "new_york_post"]
}



// WEBPACK FOOTER //
// ./src/components/pressQuotes/defaultProps.js